// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/hooks/useLockScroll.ts"
);
import.meta.hot.lastModified = "1727904225319.222";
}
// REMIX HMR END

import { useEffect } from "react";

export function useLockScroll(lock: boolean) {
    useEffect(() => {
        document.body.classList.toggle("overflow-hidden", lock);
        document.body.classList.toggle("md:overflow-auto", lock);

        return () => {
            document.body.classList.remove("overflow-hidden");
            document.body.classList.remove("md:overflow-auto");
        };
    }, [lock]);
}
